/**
 * Example data of the guided demos (never saved). Negative ids cannot exist in the database:
 * a leaked write is refused by the backend ownership checks on top of the api.js sandbox.
 */
export const DEMO_ID = Object.freeze({ student: -1, family: -1, session: -1, lesson: -1 });
export const DEMO_HOUR_PRICE = 30;
export const DEMO_LESSON_DURATION_HOURS = 1.5;
export const DEMO_LESSON_START = '17:00';

/** One object = Home "Aujourd'hui" row AND the séance's preselected student. */
export const demoLesson = (today) => Object.freeze({
  demo: true,
  student_id: DEMO_ID.student,
  family_id: DEMO_ID.family,
  first_name: 'Léa',
  last_name: 'Martin (exemple)',
  class_level: '4e',
  subjects: 'Mathématiques',
  subject: 'Mathématiques',
  next_date: today,
  start_time: DEMO_LESSON_START,
  duration_hours: DEMO_LESSON_DURATION_HOURS,
  hour_price: DEMO_HOUR_PRICE,
});

export const isDemoStudent = (student) => student?.demo === true;
